import {
  CheckCustomerLegalHold,
  GetCustomerAgreements,
  GetCustomerDetails,
  GetCustomerIdByGCId,
  GetCustomerPaymentHistory,
  GetCustomerWorkHistory,
  GetLegalCustomer,
  getGovtIdType,
} from '../../../api/user';
import { getUserDetails } from './CustomerDetailsHelperFunc';
import { hasLegalAccountReportPermission } from '../../../utils/permissions';
const customerRecordIncompleteMessage = 'Customer Record is Incomplete';

export async function MakeApiCalls(customerId: any) {
  let customerDetailsResponse: any = '';
  let activeAgreementDetails: any = '';
  let inactiveAgreementDetails: any = '';
  let legalCheck: any = '';
  let legalCustomer: any = '';
  await Promise.all([
    GetCustomerDetails(customerId),
    GetCustomerAgreements(customerId, 'Y'),
    GetCustomerAgreements(customerId, 'N'),
    CheckCustomerLegalHold(customerId),
    GetLegalCustomer({
      customerId: parseInt(customerId),
      limit: 10,
      offset: 0,
    }),
  ]).then((resp) => {
    [
      customerDetailsResponse,
      inactiveAgreementDetails,
      activeAgreementDetails,
      legalCheck,
      legalCustomer,
    ] = resp;
  });
  return {
    customerDetailsResponse: customerDetailsResponse,
    activeAgreementDetails: activeAgreementDetails,
    inactiveAgreementDetails: inactiveAgreementDetails,
    legalCheck: legalCheck,
    legalCustomer: legalCustomer,
  };
}

export async function getCustomerDetails(customerId: any, isLegalTab = false) {
  let legalCustomer: any = '';
  let customerDetailsResponse: any = '';
  let activeAgreement: any = '';
  let inActiveAgreement: any = '';
  let currentUserDetails: any = '';

  currentUserDetails = await getUserDetails();

  // accountReports only sent when on legal tab AND user has Legal permission.
  const hasLegalPermission =
    hasLegalAccountReportPermission(currentUserDetails);
  const sendAccountReports = isLegalTab && hasLegalPermission;

  await Promise.all([
    GetCustomerDetails(customerId),
    GetLegalCustomer({
      customerId: parseInt(customerId),
      limit: 10,
      offset: 0,
    }),
    GetCustomerAgreements(
      customerId,
      'Y',
      sendAccountReports ? true : undefined
    ),
    GetCustomerAgreements(
      customerId,
      'N',
      sendAccountReports ? true : undefined
    ),
  ]).then((resp) => {
    [
      customerDetailsResponse,
      legalCustomer,
      inActiveAgreement,
      activeAgreement,
    ] = resp;
  });

  return {
    customerDetailsResponse: customerDetailsResponse,
    legalCustomer: legalCustomer,
    activeAgreement: activeAgreement,
    inActiveAgreement: inActiveAgreement,
    currentUserDetails: currentUserDetails,
  };
}

export async function getLegalCustomerData(customerId: any) {
  let workHistory: any = '';
  let paymentHistory: any = '';
  let dropDowns: any = '';
  await Promise.all([
    GetCustomerPaymentHistory(customerId, '25', '0'),
    GetCustomerWorkHistory(customerId, 25, 0),
    getGovtIdType('0'),
  ]).then((resp) => {
    [paymentHistory, workHistory, dropDowns] = resp;
  });
  return {
    paymentHistory: paymentHistory,
    workHistory: workHistory,
    dropDowns: dropDowns,
  };
}

export async function getCustomerId(
  gcid: string,
  setErrorMessage: any,
  setErrorMessagePopup: any
) {
  const customerIdResponse: any = await GetCustomerIdByGCId(gcid);
  if (customerIdResponse?.data) {
    if (customerIdResponse?.status === 200) {
      return customerIdResponse.data.customerId;
    } else {
      setErrorMessage(customerRecordIncompleteMessage);
      setErrorMessagePopup(true);
    }
  } else {
    setErrorMessage(customerRecordIncompleteMessage);
    setErrorMessagePopup(true);
  }
}
